/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import styled from "styled-components";

export const simpleBarStyle = {
    backgroundColor: "#1f2937",
    overflowX: "hidden"
};

export const BrandTitle = styled.span`
    padding-left: 0;
    padding-top: 0;
    text-transform: capitalize;
    font-size: 1.0625rem;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: 0.01em;
`;

export const BrandStyle = {
    marginBottom: "0",
    display: "flex",
    alignItems: "center"
};

export const logoStyle = {
    width: 30,
    height: "auto"
};

export const BrandContainer = styled.div`
    @media (max-width: 640px) {
        display: none;
    }
`;
